<template>
    <div class="px-10 divide-y divide-gray-200">

        <div class="grid gap-12 py-14 xl:grid-cols-3">
            <div class="space-y-2">
                <h3 class="text-lg font-medium">
                    Dashboard
                </h3>
                <p class="text-sm text-gray-500">Main dashboard content blocks visible upon login.</p>
            </div>
            <div class="grid col-span-2 gap-y-4 gap-8">
                <dashboard-fields-resource-builder
                    v-model:resources="dashboardResources"
                    :file_upload_url="file_upload_url"
                    :file_delete_url="file_delete_url"
                    :zero-fields-title="zeroFieldsTitle"
                    :zero-fields-message="zeroFieldsMessage"
                    :fetching-resources="fetchingResources"
                />
                <input type="hidden" :name="name" :value="fieldsString">
            </div>
        </div>
    </div>

    <div class="bg-gray-50 px-10 py-4 text-right rounded-b sticky bottom-0 z-40 col-span-3">
                <btn
                    button-type="submit"
                    type="primary"
                    :disabled="updatingResources"
                    @click.prevent="saveResources()"
                >
                    <spinner
                        v-if="updatingResources"
                        :is-white="true"
                        class="mr-1.5"
                    />
                    {{ updatingResources ? 'Updating...' : 'Update' }}
                </btn>
            </div>
        <notification
            :show="showNotification"
            :title="notificationTitle"
            :type="notificationType"
            class="mb-20"
            @notificationClosed="this.showNotification = false"
        >
            <template #message>
                {{ notificationMessage }}
            </template>
        </notification>

</template>

<script>
import draggable from 'vuedraggable'
import Res from "../../../resources/Res";
import DashboardRes from "./DashboardRes";
import Spinner from "../../../../../elements/Spinner";
import DashboardFieldsResourceBuilder from "./DashboardFieldsResourceBuilder.vue";

export default {
    props: ['name', 'zeroFieldsMessage','zeroFieldsTitle', 'get_resource_url', 'update_url', 'file_upload_url', 'file_delete_url'],

    components: {
        DashboardFieldsResourceBuilder,
        DashboardRes,
        Res,
        draggable,
        Spinner
    },

    computed: {
        fieldsString() {
            return JSON.stringify(this.dashboardResources);
        },
    },

    data() {
        return {
            dashboardResources: [],
            showNotification: false,
            notificationType: '',
            notificationTitle: '',
            notificationMessage: '',
            fetchingResources: false,
            updatingResources: false,
            options: {
                'update_url': this.update_url,
                'file_delete_url': this.file_delete_url,
                'file_upload_url': this.file_upload_url
            },
            drag: false,
        }
    },
    created() {
        this.fetchResources()
    },
    methods: {
        fetchResources() {
            this.fetchingResources = true
            axios
                .get(this.get_resource_url)
                .then(response => {
                    this.dashboardResources = response.data
                    this.fetchingResources = false
                })
                .catch(error => {
                })
                .finally(() => {
                    this.fetchingResources = false
                });
        },
        saveResources() {
            this.updatingResources = true
            axios
                .post(this.update_url, {dashboardResources: this.fieldsString})
                .then(response => {
                    if (response.status === 200) {
                        this.showNotification = true
                        this.notificationTitle = 'Done'
                        this.notificationType = 'success'
                        this.notificationMessage = 'Dashboard resource updated successfully'
                        this.updatingResources = false
                    }
                })
                .catch(error => {
                    this.showNotification = true
                    this.notificationTitle = 'Error'
                    this.notificationType = 'warning'
                    this.notificationMessage = 'Dashboard resource update error, see console for error details.'
                })
                .finally(() => {
                    this.updatingResources = false
                });
        },
    }
}
</script>
